import { _URL } from "../../config.json";
import http from "./../http";

const apiEndpoint = _URL + "/api/ItemUnitMap";

export function deleteItemUnitMap(Id) {
  return http.delete(`${apiEndpoint}/${Id}`);
}
